<template>
  <div class="wx-cashier-page">
    <main class="wx-main">
      <section class="merchant-card">
        <div class="merchant-row">
          <div class="merchant-avatar">
            <img :src="merchantIcon" alt="" />
          </div>
          <div class="merchant-meta">
            <div class="pay-title">{{ payTitle }}</div>
            <div class="merchant-name">{{ merchantDisplayName }}</div>
          </div>
        </div>

        <div class="amount-box">
          <span class="currency">&yen;</span>
          <div class="amount-text" :class="{ empty: !displayAmount }">
            {{ displayAmount || '请输入金额' }}
          </div>
        </div>

        <div v-if="showOrderSummary" class="order-summary">
          <div v-if="orderSubject" class="order-row">
            <span class="order-label">商品名称</span>
            <span class="order-value">{{ orderSubject }}</span>
          </div>
          <div v-if="orderBody" class="order-row">
            <span class="order-label">商品说明</span>
            <span class="order-value">{{ orderBody }}</span>
          </div>
          <div v-if="payOrderInfo.outOrderNo" class="order-row">
            <span class="order-label">外部订单号</span>
            <span class="order-value">{{ payOrderInfo.outOrderNo }}</span>
          </div>
        </div>

      </section>
    </main>

    <section v-if="!isFixedAmount" class="number-pad">
      <div class="key-grid">
        <button
          v-for="key in amountKeys"
          :key="key"
          type="button"
          class="num-key"
          @click="appendAmountKey(key)"
        >
          {{ key }}
        </button>
        <button type="button" class="num-key muted" @click="deleteAmountKey">⌫</button>
        <button type="button" class="num-key" @click="appendAmountKey('0')">0</button>
        <button type="button" class="num-key" @click="appendAmountKey('.')">.</button>
      </div>
      <button class="pay-button" type="button" :disabled="!canPay" @click="pay">付款</button>
    </section>

    <section v-else class="fixed-pay-bar">
      <button class="pay-button" type="button" :disabled="!canPay" @click="pay">付款</button>
    </section>
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo } from '@/api/api'
import config from '@/config'
import { finishSuccess } from '@/utils/closePage'

export default {
  data: function () {
    return {
      merchantName: 'Jeepay商户',
      amount: '',
      resData: {},
      merchantIcon: require('../../assets/icon/merchant.svg'),
      payOrderInfo: {},
      amountKeys: ['1', '2', '3', '4', '5', '6', '7', '8', '9']
    }
  },

  computed: {
    merchantDisplayName() {
      return this.payOrderInfo.mchName || this.merchantName
    },

    isFixedAmount() {
      return !!this.payOrderInfo.amount
    },

    isOpenapiOrder() {
      return this.payOrderInfo.openapiOrder === true
    },

    payTitle() {
      return this.isOpenapiOrder ? '订单收款' : '向商户付款'
    },

    orderSubject() {
      return this.payOrderInfo.subject || ''
    },

    orderBody() {
      return this.payOrderInfo.body || ''
    },

    showOrderSummary() {
      return this.isOpenapiOrder && (this.orderSubject || this.orderBody || this.payOrderInfo.outOrderNo)
    },

    displayAmount() {
      return this.amount ? String(this.amount) : ''
    },

    canPay() {
      return !isNaN(this.amount) && Number(this.amount) > 0
    }
  },

  mounted() {
    document.title = '向商户付款'
    this.setPayOrderInfo()
  },

  methods: {
    setPayOrderInfo() {
      getPayOrderInfo(config.payWay.WXPAY.wayCode).then(res => {
        this.payOrderInfo = res

        if (Array.isArray(res.supportWayCodes) && res.supportWayCodes.indexOf(config.payWay.WXPAY.wayCode) < 0) {
          this.$router.push({ name: config.errorPageRouteName, params: { errInfo: '该收款码未开启微信扫码收款，请联系商家' } })
          return
        }

        if (res.amount) {
          this.amount = this.formatAmount(res.amount)
          if (!this.isOpenapiOrder) {
            this.pay()
          }
        }
      }).catch(res => {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
      })
    },

    formatAmount(amountFen) {
      const amount = Number(amountFen || 0) / 100
      return amount.toFixed(2).replace(/\.?0+$/, '')
    },

    tapFeedback(duration = 12) {
      if (window.navigator && typeof window.navigator.vibrate === 'function') {
        window.navigator.vibrate(duration)
      }
    },

    isSuccessResponse(res) {
      return res && (res.code === 0 || res.code === '0' || res.code === 'SUCCESS')
    },

    getPayData(res) {
      return res && res.data ? res.data : res
    },

    appendAmountKey(key) {
      this.tapFeedback()
      let value = this.amount ? String(this.amount) : ''

      if (key === '.') {
        if (value.indexOf('.') >= 0) return
        this.amount = value ? value + '.' : '0.'
        return
      }

      if (value.indexOf('.') >= 0 && value.split('.')[1].length >= 2) return

      if (value === '0') {
        this.amount = key
        return
      }

      if (value.replace('.', '').length >= 10) return

      this.amount = value + key
    },

    deleteAmountKey() {
      this.tapFeedback()
      if (!this.amount) return
      this.amount = String(this.amount).slice(0, -1)
    },

    pay() {
      this.tapFeedback(18)
      if (!this.canPay) {
        return alert('请输入金额')
      }

      getPayPackage(this.amount, config.payWay.WXPAY.wayCode).then(res => {
        if (!this.isSuccessResponse(res)) {
          return alert(res.msg)
        }

        const payData = this.getPayData(res)
        if (Number(payData.orderState) !== 1) {
          return alert(payData.errMsg)
        }

        this.resData = payData
        if (!window.WeixinJSBridge) {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
          }
        } else {
          this.onBridgeReady()
        }
      }).catch(res => {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
      })
    },

    onBridgeReady() {
      const bridge = window.WeixinJSBridge

      if (!bridge) {
        alert('当前环境未检测到微信支付组件，请在微信内打开')
        return
      }

      bridge.invoke(
        'getBrandWCPayRequest',
        JSON.parse(this.resData.payInfo),
        res => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            finishSuccess(this.payOrderInfo.returnUrl)
            return
          }

          if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            alert('支付取消')
            bridge.call('closeWindow')
            return
          }

          if (res.err_msg === 'get_brand_wcpay_request:fail') {
            alert('支付失败:' + JSON.stringify(res))
            bridge.call('closeWindow')
            return
          }

          if (res.err_msg === 'total_fee') {
            alert('缺少参数')
            bridge.call('closeWindow')
          }
        }
      )
    }
  }
}
</script>

<style lang="css" scoped>
.wx-cashier-page {
  min-height: 100vh;
  background: #f5f6f8;
  color: #1f2733;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-text-size-adjust: 100%;
}

.wx-main {
  padding: 42px 34px 430px;
}

.merchant-card {
  padding: 48px 44px 36px;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 18px 46px rgba(21, 52, 96, 0.07);
}

.merchant-row {
  display: flex;
  align-items: center;
}

.merchant-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 78px;
  height: 78px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
}

.merchant-avatar img {
  width: 100%;
  height: 100%;
  display: block;
}

.merchant-meta {
  min-width: 0;
  margin-left: 22px;
}

.pay-title {
  font-size: 26px;
  line-height: 36px;
  color: #9098a5;
}

.merchant-name {
  margin-top: 4px;
  overflow: hidden;
  color: #20242a;
  font-size: 32px;
  font-weight: 600;
  line-height: 44px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.amount-box {
  display: flex;
  align-items: baseline;
  min-height: 136px;
  margin-top: 48px;
  padding-bottom: 30px;
  border-bottom: 1px solid #edf0f5;
}

.currency {
  margin-right: 16px;
  color: #1f2733;
  font-size: 52px;
  font-weight: 600;
}

.amount-text {
  min-width: 0;
  color: #0f1724;
  font-size: 88px;
  font-weight: 600;
  line-height: 1;
  word-break: break-all;
}

.amount-text.empty {
  color: #c1c7d0;
  font-size: 56px;
  font-weight: 400;
}

.order-summary {
  margin-top: 18px;
  padding: 0;
}

.order-row {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 8px 0;
}

.order-label {
  justify-self: start;
  color: #8792a6;
  font-size: 24px;
  line-height: 1.45;
  text-align: left;
}

.order-value {
  color: #2f3a4a;
  font-size: 24px;
  line-height: 1.45;
  text-align: right;
  word-break: break-word;
}

.number-pad,
.fixed-pay-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding-bottom: env(safe-area-inset-bottom);
  background: #fff;
  box-shadow: 0 -8px 24px rgba(21, 52, 96, 0.08);
}

.number-pad {
  display: grid;
  grid-template-columns: 1fr 150px;
  gap: 1px;
  background: #dfe3eb;
}

.key-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
}

.num-key {
  height: 118px;
  border: 0;
  border-radius: 0;
  background: #fff;
  color: #1f2733;
  font-size: 44px;
  font-weight: 500;
  box-shadow: inset 0 -2px 0 rgba(15, 23, 36, 0.05);
  transition: background-color 0.08s ease, box-shadow 0.08s ease, transform 0.08s ease;
  -webkit-tap-highlight-color: transparent;
}

.num-key:active {
  background: #ecf8f0;
  box-shadow: inset 0 2px 8px rgba(15, 23, 36, 0.08);
  transform: translateY(1px);
}

.num-key.muted {
  color: #596579;
  font-size: 34px;
}

.pay-button {
  border: 0;
  border-radius: 0;
  background: #07c160;
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.08);
  transition: background-color 0.08s ease, box-shadow 0.08s ease, transform 0.08s ease;
  -webkit-tap-highlight-color: transparent;
}

.pay-button:active:not(:disabled) {
  background: #06ad56;
  box-shadow: inset 0 3px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(1px);
}

.pay-button:disabled {
  background: #a6e4bd;
}

.fixed-pay-bar {
  padding: 20px 40px calc(40px + env(safe-area-inset-bottom));
}

.fixed-pay-bar .pay-button {
  width: 100%;
  height: 88px;
  border-radius: 20px;
  box-shadow: 0 10px 24px rgba(7, 193, 96, 0.22);
}
</style>
